export default "__VITE_ASSET__DfY2YYFK__"